const LocationField = ({ label, value, onChange, icon }) => {
  return (
    <div className="form-group mb-3">
      <label className="d-block fs-sm fw-semibold mb-2">{label}</label>
      <div className="field-container border border-gray-300 d-flex align-items-center pe-3 body-bg rounded-10">
        <input
          type="text"
          className="form-control border-0 shadow-none"
          placeholder={label}
          value={value}
          onChange={onChange}
        />
        {icon && (
          <span className="d-block material-symbols-outlined icon-lg text-gray">
            {icon}
          </span>
        )}
      </div>
    </div>
  );
};

export default LocationField;
